import { render, staticRenderFns } from "./Rule.vue?vue&type=template&id=1a41c4b8&"
import script from "./Rule.vue?vue&type=script&lang=ts&"
export * from "./Rule.vue?vue&type=script&lang=ts&"
import style0 from "./Rule.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports